var map = {
  "./cs.json": [
    "ke",
    [
      "ao"
    ]
  ],
  "./en.json": [
    "nx",
    [
      "x0"
    ]
  ],
  "./pl.json": [
    "pjp",
    [
      "zm"
    ]
  ],
  "./ru.json": [
    "q6",
    [
      "kx"
    ]
  ],
  "./tr.json": [
    "UtG",
    [
      "2yj"
    ]
  ],
  "./ja.json": [
    "iDh",
    [
      "8b9"
    ]
  ],
  "./zh.json": [
    "YNw",
    [
      "mm"
    ]
  ],
  "./pt-br.json": [
    "NRD",
    [
      "fnj"
    ]
  ],
  "./de.json": [
    "Aed",
    [
      "i"
    ]
  ],
  "./es.json": [
    "fa",
    [
      "lw"
    ]
  ],
  "./fr.json": [
    "P2",
    [
      "t3"
    ]
  ],
  "./it.json": [
    "E7",
    [
      "e7"
    ]
  ],
  "./ko.json": [
    "aa",
    [
      "g"
    ]
  ],
  "./pt.json": [
    "WJe",
    [
      "0jd"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "QD";
module.exports = __rspack_async_context;
